import React from "react";
import HistorialCambios from "../../../components/HistorialCambios";

const HistorialPisos = () => (
  <HistorialCambios
    endpoint="/api/pisos/historial"
    titulo="Historial de cambios — Pisos"
    entidadLabel="Piso"
    volverA="/admin/pisos"
    sugerenciasEndpoint="/api/pisos/"
    sugerenciasCampo="abreviatura"
  />
);

export default HistorialPisos;
